import { defineComponent } from 'vue'
import './style.sass'

export default defineComponent({

  setup () {
    return () => {
      return (
        <div class="header">
          <div class="container">
            <a href="https://cable.ru/">
              <div class="logo" />
            </a>
            <div class="header-menu">
              <div class="link">
                <a href="https://cable.ru/products/" class="catalog-link">Перейти в каталог</a>
              </div>
              <div class="link">
                <a href="https://cable.ru/cart/" class="basket-link">Корзина</a>
              </div>
            </div>
            <div class="header-phone">
              <div class="header-phone-elem">
                <a href="tel:+7 (495) 646-08-58">
                  <div class="header-phone-container">
                    <span>+7 (495)</span>
                    646-08-58
                  </div>
                    <span class="header-phone-text">круглосуточно</span>
                </a>
              </div>
              <div class="header-phone-elem">
                <a href="tel:8 (800) 333-11-48">
                  <div class="header-phone-container">
                    <span>8 (800)</span>
                    333-11-48
                  </div>
                  <span class="header-phone-text">бесплатно для регионов</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
})